import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useCallback,
} from "react";
import { DownloadTutor } from "./phone/DownloadTutor";
import { DownloadPage } from "./DownloadPage";
import { report } from "../utils/report";
import { getWebviewUa } from "../utils/getWebviewUa";

export const useIsPhoneView = (forceW?: number) => {
  const [phoneView, setPhoneView] = useState(
    document.documentElement.clientWidth < (forceW || 1180),
  );
  useEffect(() => {
    const checkWindowWidth = () => {
      const w = document.documentElement.clientWidth;
      if (w < (forceW || 1180)) {
        setPhoneView(true);
      } else {
        setPhoneView(false);
      }
    };

    checkWindowWidth();
    window.addEventListener("resize", checkWindowWidth, false);
    return () => window.removeEventListener("resize", checkWindowWidth);
  }, []);
  return phoneView;
};

export interface PageContextInfo {
  currentPage: string;
  changeCurrentPage: (page: string) => void;
  // 埋点上报
  downloadClickReport: (btnType?: string) => void;
}

export const PageContext = createContext<PageContextInfo>({
  currentPage: "main",
  changeCurrentPage: () => {},
  downloadClickReport: () => {},
});

export function usePageContext(): PageContextInfo {
  return useContext(PageContext);
}

export const DownLoadAppPageView = () => {
  return <DownloadPage />;
};

export const Download = () => {
  const isPhone = useIsPhoneView(767);
  const [page, setPage] = useState("main");

  useEffect(() => {
    const params: any = {
      from: "other",
      site: "main",
    };
    if (isPhone) {
      const from = new URLSearchParams(window.location.search).get("from");
      params.action = from === "qr" ? "qr_code" : "manual";
      if (from === "qr") params.scan_app = getWebviewUa();
    }
    report(
      isPhone ? "h5_download_page_show" : "web_download_page_show",
      params,
    );
  }, [isPhone]);

  const downloadClickReport = useCallback(
    (btnType?: string) => {
      const params: any = { site: "main" };
      if (btnType) params.click_btn = btnType;
      report(
        isPhone ? "h5_download_page_click" : "web_download_page_click",
        params,
      );
    },
    [isPhone],
  );
  return (
    <PageContext.Provider
      value={{
        currentPage: page,
        changeCurrentPage: setPage,
        downloadClickReport,
      }}
    >
      {page === "main" ? <DownLoadAppPageView /> : <DownloadTutor />}
    </PageContext.Provider>
  );
};
